import { getSemanticSortValue } from '../../client/routes/fetch/citySearchPage/utils/semanticSortValue';
export const SORT_DIRECTIONS = {
	distance: { type: 'distance', order: 'asc' },
	featured: { type: 'featured', order: 'asc' },
	recommended: { type: 'recommended', order: 'asc' },
	'review-rating': { type: 'review-rating', order: 'desc' },
	tiering: { type: 'featured', order: 'asc' },
};

const SSS_SORTS = [
	SORT_DIRECTIONS.featured.type,
	SORT_DIRECTIONS.recommended.type,
];

export default function sortParam(sort) {
	return SORT_DIRECTIONS[sort] || SORT_DIRECTIONS.recommended;
}

export const processSortAndVariant = (sort, q) => {
	// By default 'featured' if no sort is provided
	const resolvedSemanticSort = getSemanticSortValue({
		q,
		sort,
	});
	const resolvedSort = q ? resolvedSemanticSort : sort;

	if (SSS_SORTS.includes(sort)) {
		return {
			...sortParam(resolvedSort),
			variant: { type: 'sss' },
		};
	}

	// By default 'recommended' if no sort is provided
	return sortParam(resolvedSort);
};
